import React, { Suspense, Fragment, lazy, useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import GuestGuard from './components/Auth/GuestGuard';
import AuthGuard from './components/Auth/AuthGuard';
import Login from './views/auth/signin/SignIn1';

import { BASE_URL } from './config/constant';
import { ConfigContext } from './contexts/ConfigContext.js';
import PreDash from './views/FrontPage/FrontPage';
const RenderRoutes = (routes = []) => {
   const {state} = useContext(ConfigContext);  


   

  return <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;
        if(route.routes){
          const filterData = route.routes.filter(item => item.type == state.type)
          return  filterData.map(_ => <Route
            key={i}
            path={route.path}
            exact={route.exact}
            element={
              <Guard>
                <Layout>{route.routes ? RenderRoutes(route.routes) : <Element props={true} />}</Layout>
              </Guard>
            }
          />)
        }
        if(state.type == route.type){
          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              element={
                <Guard>
                  <Layout>{route.routes ? RenderRoutes(route.routes) : <Element props={true} />}</Layout>
                </Guard>
              }
            />
          );
        }
       
      })}
    </Routes>
  </Suspense>
};

export const routes = [
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/signin-1',
    // element: lazy(() => import('./views/auth/signin/SignIn1'))
    element: Login,
    type:"login"
  },
  
  {
    exact: true,
    guard: GuestGuard,
    path: '/',
    // element: lazy(() => import('./views/auth/signin/SignIn1'))
    element: Login,
    type:"login"
  },
  {
    exact: true,
    path: '/auth/signup-1',
    element: lazy(() => import('./views/auth/signup/SignUp1')),
     type:"login"
  },
  {
    exact: true,
    path: '/auth/signup-1?inapp=true',
    element: lazy(() => import('./views/auth/signup/SignUp1')),
     type:"login"
  },
  {
    exact: true,
    path: '/privacy-policy',
    element: lazy(() => import('./views/Policies/PrivacyPolicy.js')),
     type:"login"
  },
  {
    exact: true,
    path: '/terms-disclaimer-policy',
    element: lazy(() => import('./views/Policies/TermsAndDisclaimer.js')),
     type:"login"
  },
  {
    exact: true,
    path: '/refund-cancellation-policy',
    element: lazy(() => import('./views/Policies/RefunAndcAncel.js')),
     type:"login"
  },
  {
    exact: true,
    path: '/auth/reset-password-1',
    element: lazy(() => import('./views/auth/reset-password/ResetPassword1')),
     type:"login"
  },
  {
    exact: false,
    path: '*',
    element: Login,
     type:"login"
  },
  // {
  //   exact: true,
  //   path: '/pre-dash',
  //   element: PreDash,
  //    type:"login"
  // },
  {
    exact: true,
    path: '/auth/affiliated',
    element: lazy(() => import('./views/auth/AffiliatedLogin/AffiliatedLogin')),
     type:"login"
  },
  {
    exact: true,
    path: '/auth/profile-settings',
    element: lazy(() => import('./views/auth/ProfileSettings')),
     type:"login"
  },
  {
    exact: true,
    path: '/auth/tabs-auth',
    element: lazy(() => import('./views/auth/TabsAuth')),
     type:"login"
  },
  {
    exact: true,
    path: '/affiliated-dashboard',
    element: lazy(() => import('./views/AffiliatedDashboard/index')),
     type:"login"
  },
  // {
  //   exact: true,
  //   path: '/todayspl',
  //   element: lazy(() => import('./views/TodaySpecial/Todayspl.jsx')),
  //    type:"login"
  // },
 
  {
    path: '*',
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      {
        exact: true,
        path: '/ledger',
        element: lazy(() => import('./views/ledger/Ledger')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-dashboard',
        element: lazy(() => import('./views/Dashboard/index')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/todayspl',
        element: lazy(() => import('./views/TodaySpecial/Todayspl.jsx')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/resturant',
        element: lazy(() => import('./views/Resturant/page.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/malabar',
        element: lazy(() => import('./views/MalaBar/Malabar.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/pre-dash',
        element: PreDash,
         type: 'Member'
      },
      {
        exact: true,
        path: '/',
        element: PreDash,
         type: 'Member'
      }, {
        exact: true,
        path: '*',
        element: PreDash,
         type: 'Member'
      },
      // {
      //   exact: true,
      //   path: '/',
      //   element: lazy(() => import('./views/Dashboard/index')),
      //   type: 'Member'
      // },
      // {
      //   exact: false,
      //   path: '*',
      //   element: lazy(() => import('./views/Dashboard/index')),
      //   type: 'Member'
      // },
      {
        exact: false,
        path: '*',
        element: lazy(() => import('./views/AdminDashboard/index')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/member-room',
        element: lazy(() => import('./views/MemberRoom/Room')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/room-available',
        element: lazy(() => import('./views/MemberRoom/RoomAvailable')),
        type: 'Member'
      },
      
      {
        exact: true,
        path: '/booking-details',
        element: lazy(() => import('./views/MemberRoom/Bookingdetails.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/myprofile',
        element: lazy(() => import('./views/MyProfile/MyProfile')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/changepassword',
        element: lazy(() => import('./views/ChangePassword/ChangePassword')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/changepassword',
        element: lazy(() => import('./views/ChangePassword/ChangePassword')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/member-event',
        element: lazy(() => import('./views/MemberEvent/Event')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-kot',
        element: lazy(() => import('./views/MemberKot/Viewkot')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-onlinepayment',
        element: lazy(() => import('./views/MemberPayment/OnlinePayment')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-kot2',
        element: lazy(() => import('./views/MemberKot/Bookkot')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-qr',
        element: lazy(() => import('./views/MemberORCode/QRCode')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/admin-dashboard',
        element: lazy(() => import('./views/AdminDashboard/index')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/',
        element: lazy(() => import('./views/AdminDashboard/index')),
        type: 'Admin'
      },
      {
        exact: true,
        // path: 'member-onlinepayment',
        path: 'admin-paymentlist',
        element: lazy(() => import('./views/AdminDashboard/PaymentLIst/PaymentList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/Payment-success',
        element: lazy(() => import('./utills/Payment/PaymentSuccess.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/Payment-failure',
        element: lazy(() => import('./utills/Payment/PaymentFailure.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/Payment-cancel',
        element: lazy(() => import('./utills/Payment/PaymentCancel.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/admin-memberlist',
        element: lazy(() => import('./views/AdminDashboard/MemberList/MemberList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/admin-newsletter',
        element: lazy(() => import('./views/AdminDashboard/NewsLetter/NewsLetter')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/member-newsletter',
        element: lazy(() => import('./views/MemberNews/News')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-club',
        element: lazy(() => import('./views/MemberClub/ClubList')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-clubdetails',
        element: lazy(() => import('./views/MemberClub/ClubDetails')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-bill',
        element: lazy(() => import('./views/MemberBill/Bills')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-noticeboard',
        element: lazy(() => import('./views/MemberNotice/NoticeBoard')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-committee',
        element: lazy(() => import('./views/MemberCommittee/CommitteeMember')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/office-bearers',
        element: lazy(() => import('./views/MemberCommittee/officebearers.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/memroom',
        element: lazy(() => import('./views/membook/Membook')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/member-about',
        element: lazy(() => import('./views/Aboutus/About')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/cwmember-about',
        element: lazy(() => import('./views/Aboutus/CW_About')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/admin-about',
        element: lazy(() => import('./views/Aboutus/CW_About')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/member-footer',
        element: lazy(() => import('./views/Footer/Footer'))
      },
      {
        exact: true,
        path: '/admin-memberdetails',
        element: lazy(() => import('./views/AdminDashboard/MemberList/MemberDetails')),
        type: 'Admin'
      },

      {
        exact: true,
        path: '/admin-eventlist',
        element: lazy(() => import('./views/AdminDashboard/Eventcreate/EventList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/admin-eventcreate',
        element: lazy(() => import('./views/AdminDashboard/Eventcreate/Eventcreate')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/admin-eventreports',
        element: lazy(() => import('./views/AdminDashboard/Eventcreate/EventReports')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/admin-addgallery',
        element: lazy(() => import('./views/AdminDashboard/gallery/gallery.js')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/admin-gallerylist',
        element: lazy(() => import('./views/AdminDashboard/gallery/gallerylist.js')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/digital-showroom-form',
        element: lazy(() => import('./views/AdminDashboard/Digital Showroom/ShowroomForm.js')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/digital-showroom-list',
        element: lazy(() => import('./views/AdminDashboard/Digital Showroom/ShowroomList.js')),
        type: 'Admin'
      },

      {
        exact: true,
        path: '/member-event-info',
        element: lazy(() => import('./views/MemberEvent/EventInfo')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/admin-noticelist',
        element: lazy(() => import('./views/AdminDashboard/NoticeBoard/NoticeList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/membersuggestionlist',
        element: lazy(() => import('./views/Suggestion/suggestionlist.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/suggestion',
        element: lazy(() => import('./views/Suggestion/Suggestion.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/party-hall',
        element: lazy(() => import('./views/PartyHall/PartHall.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/hall-list',
        element: lazy(() => import('./views/AdminDashboard/HallBooking/HallList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/hall-create',
        element: lazy(() => import('./views/AdminDashboard/HallBooking/HallCreate')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/admin-noticecreate',
        element: lazy(() => import('./views/AdminDashboard/NoticeBoard/NoticeCreate')),
        type: 'Admin'
      },
           {
        exact: true,
        path: '/admin-affiliatedlist',
        element: lazy(() => import('./views/AdminDashboard/AffliatedClubs/AffiliatedList.js')),
        type: 'Admin'
      },
        {
        exact: true,
        path: '/admin-affiliatedcreate',
        element: lazy(() => import('./views/AdminDashboard/AffliatedClubs/AffiliatedInput.js')),
        type: 'Admin'
      },

      {
        exact: true,
        path: '/facility_list',
        element: lazy(() => import('./views/FacilityBooking/FacilityList')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_booking',
        element: lazy(() => import('./views/FacilityBooking/FacilityBooking')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_available',
        element: lazy(() => import('./views/FacilityBooking/FacilityAvailabile')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_slot_list',
        element: lazy(() => import('./views/FacilityBooking/SlotList')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_slot_available',
        element: lazy(() => import('./views/FacilityBooking/SlotAvailable')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_invoice',
        element: lazy(() => import('./views/FacilityBooking/FacilityInvoice')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/date_range',
        element: lazy(() => import('./views/FacilityBooking/DateSelector')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_view',
        element: lazy(() => import('./views/AdminDashboard/FacilityBooking/FacilityList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/facility_add',
        element: lazy(() => import('./views/AdminDashboard/FacilityBooking/FacilityAdd')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/slot_list',
        element: lazy(() => import('./views/AdminDashboard/FacilityBooking/SlotBooking/SlotList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/slot_add',
        element: lazy(() => import('./views/AdminDashboard/FacilityBooking/SlotBooking/SlotAdd')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/notification_create',
        element: lazy(() => import('./views/AdminDashboard/EventNotification/EventNotificreate')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/notification_list',
        element: lazy(() => import('./views/AdminDashboard/EventNotification/EventNotifiList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/qr_attendance',
        element: lazy(() => import('./views/QrAttendance/QrAttendance')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/view_bill',
        element: lazy(() => import('./views/ViewBill/BillView')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/invoice_bill',
        element: lazy(() => import('./views/ViewBill/InvoiceView')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/club_visit',
        element: lazy(() => import('./views/ClubVisit/ClubVisit')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/rules',
        element: lazy(() => import('./views/Rules/Rules')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/dresscode_rules',
        element: lazy(() => import('./views/DressCodeRules/Rules')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/feedback',
        element: lazy(() => import('./views/FeedBack/FeedBack')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/membergallery',
        element: lazy(() => import('./views/Gallery/Gallery.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/businessgallery',
        element: lazy(() => import('./views/BusinessShowroom/index.js')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/feedback_list',
        element: lazy(() => import('./views/FeedBack/FeedbackList')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_slot',
        element: lazy(() => import('./views/Subscription/Slot')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/facility_slotdetails',
        element: lazy(() => import('./views/Subscription/Slotdetails')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/order_details',
        element: lazy(() => import('./views/MemberKot/OrderDetails')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/item_details',
        element: lazy(() => import('./views/MemberKot/itemDetails')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/golf-booking',
        element: lazy(() => import('./views/Golf_SlotBooking/index')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/golf-bookinglist',
        element: lazy(() => import('./views/Golf_SlotBooking/GolfBooking.js')),
        type: 'Member'
      },
      // {
      //   exact: true,
      //   path: '/golf-bookinglist',
      //   element: lazy(() => import('./views/GolfBooking/GolfBooking')),
      //   type: 'Member'
      // },
      {
        exact: true,
        path: '/staff',
        element: lazy(() => import('./views/AdminDashboard/Staffs/Staff')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/staff_add',
        element: lazy(() => import('./views/AdminDashboard/Staffs/StaffAdd')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/feedbacklist',
        element: lazy(() => import('./views/AdminDashboard/FeedBack/Feedback')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/feedbackadd',
        element: lazy(() => import('./views/AdminDashboard/FeedBack/FeedbackAdd')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/rules_list',
        element: lazy(() => import('./views/AdminDashboard/Rules/Rules')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/rules_add',
        element: lazy(() => import('./views/AdminDashboard/Rules/RulesAdd')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/dresscode_rules_list',
        element: lazy(() => import('./views/AdminDashboard/DressRules/DressRules')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/dresscode_rules_add',
        element: lazy(() => import('./views/AdminDashboard/DressRules/DressRulesAdd')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/rooms',
        element: lazy(() => import('./views/AdminDashboard/Room/Rooms')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/rooms_list',
        element: lazy(() => import('./views/MemberRoom/RoomsList')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/order_detail',
        element: lazy(() => import('./views/AdminDashboard/OnlineOrder/OnlineOrder')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/slot_details',
        element: lazy(() => import('./views/AdminDashboard/SlotBooking/SlotList')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/slot-create',
        element: lazy(() => import('./views/AdminDashboard/SlotBooking/SlotCreate')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/facility-create',
        element: lazy(() => import('./views/AdminDashboard/SlotBooking/FacilityCreate')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/member-slot-booking-details',
        element: lazy(() => import('./views/AdminDashboard/SlotBooking/MembersBooking')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/movie_booking',
        element: lazy(() => import('./views/MovieBooking/MovieBooking')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/movie-details',
        element: lazy(() => import('./views/AdminDashboard/MovieBooking/MovieDetails')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/movie-add',
        element: lazy(() => import('./views/AdminDashboard/MovieBooking/MovieAdd')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/movie-reports',
        element: lazy(() => import('./views/AdminDashboard/MovieBooking/Report')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/pending-bills',
        element: lazy(() => import('./views/PendingBills/PendingBills')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/room-approve',
        element: lazy(() => import('./views/AdminDashboard/Room/RoomApprove')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/vote-Result',
        element: lazy(() => import('./views/MovieBooking/SurveyResult')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/vote-poll',
        element: lazy(() => import('./views/MovieBooking/Poll')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/change-request',
        element: lazy(() => import('./views/AdminDashboard/ChangeRequests/RequestTable')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/suggestionlist',
        element: lazy(() => import('./views/AdminDashboard/AdminSuggestion/suggestionlist.js')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/confirm-request',
        element: lazy(() => import('./views/AdminDashboard/ChangeRequests/ConfirmRequest')),
        type: 'Admin'
      },
      {
        exact: true,
        path: '/front-page',
        element: lazy(() => import('./views/Account/fppage')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/enter-chat',
        element: lazy(() => import('./views/Chat/EnterChat')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/chat-page',
        element: lazy(() => import('./views/Chat/Chat')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/account_view',
        element: lazy(() => import('./views/Account/Account')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/check-in',
        element: lazy(() => import('./views/CheckIn/Checkin')),
        type: 'Member'
      },
      {
        exact: true,
        path: '/Willigtonhistory',
        element: lazy(() => import('./views/history/history')),
        type: 'Member'
      },
      {
        path: '*',
        exact: true,
        element: () => <Navigate to={BASE_URL} />
      },
      
     
    ]
  },
  
];

export default RenderRoutes;
